import { render, staticRenderFns } from "./ChangeOrderType.vue?vue&type=template&id=64a148b6&scoped=true&"
import script from "./ChangeOrderType.vue?vue&type=script&lang=js&"
export * from "./ChangeOrderType.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOrderType.vue?vue&type=style&index=0&id=64a148b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a148b6",
  null
  
)

export default component.exports